export default "__VITE_ASSET__rYJ38wz7__"